import { cleanName, orNull } from '../../../common/utils/text';

// Builds the animal create/update payload (api-reference/admin-animals.md).
// `birth` is the raw 'YYYY-MM-DD' input value — sent verbatim, never through
// new Date() (decisión 0004). When sin bautizar, name/number go as null.
// `status` is NOT included here (POST lo rechaza); el edit lo agrega aparte.
export function buildAnimalPayload(form) {
    const baptized = form.baptized !== false;
    return {
        baptized,
        name:        baptized ? cleanName(form.name) : null,
        number:      baptized ? cleanName(form.number) : null,
        register:    orNull(form.register),
        race_id:     form.race_id ? Number(form.race_id) : null,
        sex:         form.sex,
        birth:       form.birth || null,
        appearance:  orNull(form.appearance),
        description: orNull(form.description),
    };
}
